<template>
  <div class="demo">
    <browse-home :demo="true" @demoActivated="showPlaylistGroup" v-if="!playlistGroupId" />
    <playlist-group-demo
      :canReturn="canReturn"
      :shouldPop="shouldPop"
      :playlistGroupId="playlistGroupId"
      @demoActivated="openDialog"
      v-else
    />

    <div :class="`demo__dialog ${isDialogOpen ? 'demo__dialog--open' : ''}`" @click.stop="closeDialog">
      <div ref="dialog" class="demo__dialog__body" @click.stop="openDialog">
        <div class="demo__dialog__body__overlay">
          <div class="demo__dialog__body__overlay__close" @click.stop="closeDialog" />
        </div>
        <div class="demo__dialog__body__cta">
          <eye-icon outlined />
          {{ $t('demo.dialog.text') }} <a>{{ $t('demo.dialog.CTA') }}</a>
        </div>
        <checkout-flow :isInsideDialog="true" />
      </div>
    </div>
  </div>
</template>

<script>
import windowStore from '@/store/modules/window.store'

let canReturn = false
let shouldPop = false

export default {
  name: 'demo',
  data: () => ({
    isDialogOpen: false
  }),
  watch: {
    '$route.params.playlistGroup': () => {
      window.scrollTo({ top: 0, behavior: 'auto' })
    }
  },
  computed: {
    playlistGroupId() {
      return this.$route.params.playlistGroup
    },
    canReturn() {
      return canReturn
    },
    shouldPop() {
      return shouldPop
    }
  },
  methods: {
    showPlaylistGroup(id) {
      this.$router.push({ name: 'demo', params: { playlistGroup: id } })
    },
    openDialog() {
      this.isDialogOpen = true
      document.body.style.overflow = 'hidden'
    },
    closeDialog() {
      this.isDialogOpen = false
      this.$refs.dialog.scrollTo(0, 0)
      document.body.style.overflow = 'auto'
    }
  },
  metaInfo: () => ({
    title: 'PlayKids | Demo'
  }),
  beforeRouteEnter(to, from, next) {
    if (windowStore.state.countryCode !== 'BR') {
      return next({ name: 'inactive' })
    }

    canReturn = !!from.name
    shouldPop = from.name === 'demo'
    next()
  }
}
</script>

<style lang="scss" scoped>
.demo {
  &__dialog {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events: none;
    transition: background-color 0.2s;

    &--open {
      background-color: rgba(black, 0.6);
      pointer-events: all;
    }

    &--open &__body {
      margin-top: 25px;
      overflow: auto;

      &__cta {
        opacity: 0;
        margin-bottom: -50px;
        cursor: default;
      }

      &__overlay__close {
        display: block;
      }
    }

    &__body {
      position: relative;
      margin-top: calc(100vh - 50px);
      width: 100%;
      max-height: calc(100vh - 25px);
      background-color: white;
      box-shadow: 0 -3px 10px #A217AB26;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      transition: margin 0.2s;
      pointer-events: all;
      overflow: hidden;

      &__cta {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        cursor: pointer;
        font: {
          size: 12px;
          weight: normal;
        }

        & > .eye-icon {
          width: 10px;
          height: 12px;
          margin-right: 6px;
          margin-bottom: 3px;
        }

        & > a {
          font-weight: 900;
          margin-left: 4px;
        }
      }

      &__overlay {
        z-index: 1;
        position: sticky;
        top: 0;
        left: 0;
        width: 100%;

        &__close {
          display: none;
          position: absolute;
          top: 2px;
          right: 4px;
          width: 16px;
          height: 16px;
          padding: 8px;
          background-color: #453D4C;
          mask: url('~@/assets/close-icon.svg') no-repeat center/16px 16px;
          box-sizing: content-box;
          cursor: pointer;
        }
      }

      & > .checkout-flow {
        padding: 0;
      }
    }
  }

  @media screen and (min-width: 350px) {
    &__dialog__body__cta {
      font-size: 14px;
    }
  }

  @media screen and (min-width: 768px) and (min-height: 600px) {
    &__dialog {
      justify-content: center;

      &--open &__body {
        border-radius: 18px;
        margin-top: 0;
      }

      &__body {
        margin-left: auto;
        margin-right: auto;
        width: 500px;
        max-height: calc(100vh - 100px);
        border-top-left-radius: 18px;
        border-top-right-radius: 18px;

        &__cta {
          font-size: 16px;

          & > .eye-icon {
            width: 14px;
            height: 18px;
            margin-bottom: 4px;
          }
        }
      }
    }
  }

  @media screen and (min-width: 1200px), (min-height: 1300px) {
    &__dialog {
      justify-content: center;

      &--open &__body__cta {
        margin-bottom: -90px;
      }

      &__body {
        width: 650px;
        margin-top: calc(100vh - 60px);
        max-height: calc(100vh - 50px);

        &__cta {
          font-size: 18px;
          height: 60px;
        }

        & > .checkout-flow {
          padding: 15px 25px;
        }
      }
    }
  }
}
</style>
